import React from 'react';
import FileGroupingFileSpecExportConfigurationComponentVM from './FileGroupingFileSpecExportConfigurationComponentVM';
import { observer } from 'mobx-react';
import { Neo, NeoGrid } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';
import FileGroupingExportFileSpecLookup from '../Models/Lookups/FileGroupingExportFileSpecLookup';
import Loading from '../../../App/Components/Loading/Loading';
import ManageFileGroupingFileSpecExportConfigurationComponent from '../Components/ManageFileGroupingFileSpecExportConfigurationComponent';
import RawGenericExportMappingComponent from '../../RawGenericExportMappings/Components/RawGenericExportMappingComponent';

interface IFileGroupingFileSpecExportConfigurationComponentProps {
    viewModel: FileGroupingFileSpecExportConfigurationComponentVM;
}

@observer
export default class FileGroupingFileSpecExportConfigurationComponent extends React.Component<IFileGroupingFileSpecExportConfigurationComponentProps> {
    public render() {
        const viewModel = this.props.viewModel;

        return (
            <>
                {(viewModel.taskRunner.isBusy) && <Loading />}
                {viewModel.showManageFileGroupingExportFileSpecComponent === true &&
                    <ManageFileGroupingFileSpecExportConfigurationComponent
                        viewModel={viewModel}
                        onCancel={() => viewModel.cancel()}
                        onSave={() => viewModel.savebrokerExportConfiguration()}
                    />
                }
                {viewModel.showRawGenericExportMappingComponent === true &&
                    <RawGenericExportMappingComponent
                        viewModel={viewModel.rawGenericExportMappingComponentVM}
                        onCancel={() => viewModel.cancelRawGenericMapping()}
                    />
                }
                {viewModel.showManageFileGroupingExportFileSpecComponent === false && 
                    viewModel.showRawGenericExportMappingComponent === false &&
                    <Neo.Card title={TextConstants.Titles.BrokerExportConfiguration} className="m-1">
                        <div className="row">
                            <div className="col text-right">
                                <Neo.Button className="btn btn-default" variant="primary"
                                    onClick={() => viewModel.addNewFileGroupingExportFileSpec()}
                                >{TextConstants.Buttons.AddBrokerExportConfiguration}</Neo.Button>
                            </div>
                        </div>
                        <Neo.Form
                            model={viewModel.fileGroupingExportFileSpecSearchCriteria}>
                            <div className="row">
                                <div className="col-lg-3">
                                    <Neo.FormGroup bindContext={viewModel.fileGroupingExportFileSpecSearchCriteria.meta.serviceProviderGroupingName} label={TextConstants.Labels.Broker}>
                                        <Neo.AutoCompleteDropDown
                                            itemSource={viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                                            bind={viewModel.fileGroupingExportFileSpecSearchCriteria.meta.staticServiceProviderFileGroupingId}
                                            bindDisplay={viewModel.fileGroupingExportFileSpecSearchCriteria.meta.serviceProviderGroupingName}
                                            displayMember={"serviceProviderGroupingName"}
                                            onItemSelected={() => viewModel.pageManager.refreshData()}
                                            items={viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data
                                                .sort((x, y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))} />
                                    </Neo.FormGroup>
                                </div>
                                <div className="col-lg-3">
                                    <Neo.FormGroup bindContext={viewModel.fileGroupingExportFileSpecSearchCriteria.meta.fileTypeConcatenated} label={TextConstants.Labels.ExportReport}>
                                        <Neo.AutoCompleteDropDown
                                            itemSource={viewModel.staticExportFileSpecApiClient.getExportFileSpecDropdownList}
                                            bind={viewModel.fileGroupingExportFileSpecSearchCriteria.meta.staticExportFileSpecId}
                                            bindDisplay={viewModel.fileGroupingExportFileSpecSearchCriteria.meta.fileTypeConcatenated}
                                            displayMember={"propertiesConcatenated"}
                                            onItemSelected={() => viewModel.pageManager.refreshData()}
                                            items={viewModel.staticExportFileSpecApiClient.getExportFileSpecDropdownList(" ").then((arr) => arr.data.slice(0, 10)
                                                .sort((x, y) => x.propertiesConcatenated!.localeCompare(y.propertiesConcatenated!)))}
                                        />
                                    </Neo.FormGroup>
                                </div>
                            </div>
                            <Neo.FormGroup
                                suppressLabel={true}
                                bind={viewModel.fileGroupingExportFileSpecSearchCriteria.meta.searchCriteria}
                                placeholder={TextConstants.PlaceHolder.SearchBrokerExportConfigurations}
                                append={
                                    <Neo.Button className="btn-small" variant="secondary" onClick={() => viewModel.clearSearch()}>
                                        { TextConstants.Buttons.ClearSearch }
                                    </Neo.Button>
                                }>
                            </Neo.FormGroup>
                        </Neo.Form>
                        <Neo.Pager pageManager={viewModel.pageManager} pageControlProps={{ pageSizeLabel: "Show:" }}>
                            <div className="horizontalScroll">
                                {viewModel.pageManager.totalRecords > 0 &&
                                    <NeoGrid.Grid<FileGroupingExportFileSpecLookup> className={"table-striped"}>
                                        {(item, meta) => (
                                            <NeoGrid.Row key={item.staticServiceProviderFileGroupingExportFileSpecId}>
                                                <NeoGrid.Column display={meta.staticServiceProviderGroupingName} label={TextConstants.Labels.Broker} />
                                                <NeoGrid.Column display={meta.reportName} />                                                
                                                <NeoGrid.Column display={meta.isExcluded} label={TextConstants.Labels.Excluded} />
                                                <NeoGrid.ButtonColumn className="text-center">
                                                    <Neo.Button
                                                        variant="primary" isOutline
                                                        onClick={() => viewModel.viewRawGenericExportMappings(item.staticServiceProviderFileGroupingId, item.staticExportFileSpecId)}>
                                                            {TextConstants.Buttons.ViewMappings}
                                                    </Neo.Button>
                                                </NeoGrid.ButtonColumn>
                                                <NeoGrid.ButtonColumn label={TextConstants.Labels.Edit} className="text-center">
                                                    <Neo.Button
                                                        variant="primary" isOutline className="btn-small"
                                                        onClick={() => viewModel.editFileGroupingExportFileSpec(item)}>
                                                        <i className="fa fa-edit" />
                                                    </Neo.Button>
                                                </NeoGrid.ButtonColumn>
                                            </NeoGrid.Row>
                                        )}
                                    </NeoGrid.Grid>
                                }
                            </div>
                        </Neo.Pager>
                        <div className="row">
                            <div className="col pt-3">
                                <Neo.Button className="btn btn-default"
                                    onClick={() => viewModel.backToFileConfigurations()}
                                    variant="secondary"
                                >{TextConstants.Buttons.Back}</Neo.Button>
                            </div>
                        </div>
                    </Neo.Card>
                }
            </>
        );
    }
}